import { render, staticRenderFns } from "./communicate.vue?vue&type=template&id=729af60e&scoped=true&"
import script from "./communicate.vue?vue&type=script&lang=js&"
export * from "./communicate.vue?vue&type=script&lang=js&"
import style0 from "./communicate.vue?vue&type=style&index=0&id=729af60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729af60e",
  null
  
)

export default component.exports